function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#ced6e0;}.a,.b{fill-rule:evenodd;}.b{fill:#fff;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-1257 -44)"
}, /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M125,17.5A16.5,16.5,0,1,1,141.5,34,16.5,16.5,0,0,1,125,17.5Z",
  transform: "translate(1132 43)"
}), /*#__PURE__*/React.createElement("path", {
  className: "b",
  d: "M141.006,14.412l.034.571-.577-.07a9.386,9.386,0,0,1-5.493-2.7l-.762-.757-.2.559a3.363,3.363,0,0,0,.715,3.449c.462.489.358.559-.438.268a1.362,1.362,0,0,0-.543-.128,4.16,4.16,0,0,0,.416,1.561,3.728,3.728,0,0,0,1.581,1.491l.565.268-.669.012c-.646,0-.669.012-.6.256A3.49,3.49,0,0,0,137.2,21.1l.716.245-.624.373a6.5,6.5,0,0,1-3.093.862,3.421,3.421,0,0,0-.946.093,8.785,8.785,0,0,0,2.227,1.025,9.751,9.751,0,0,0,7.572-.862,10.132,10.132,0,0,0,3.843-4.521,12.031,12.031,0,0,0,.785-3.5c0-.536.034-.606.681-1.247a7.678,7.678,0,0,0,.808-.9c.115-.221.1-.221-.485-.023-.981.349-1.12.3-.635-.221a3.388,3.388,0,0,0,.785-1.247c0-.035-.173.023-.369.128a6.469,6.469,0,0,1-1.016.4l-.623.2-.566-.385a4.675,4.675,0,0,0-.981-.513,3.945,3.945,0,0,0-2.02.047A3.336,3.336,0,0,0,141.006,14.412Z",
  transform: "translate(1132.75 43.1)"
}));

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/Twitter.95824222.svg";
export { ForwardRef as ReactComponent };